module.exports = __webpack_public_path__ + "img/circle-arrow-down.e535df59.png";